module.exports = __webpack_public_path__ + "23dd1145e14f45c8dbdedd1f56139363.MP3";